export default __webpack_public_path__ + "static/media/thumbUpInactive.2228ef95.svg";